import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export const Datenschutz = () => {
  return (
    <div className="overflow-hidden pt-20" data-testid="datenschutz-page">
      <section className="py-24 md:py-32">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <motion.div {...fadeUp} viewport={{ once: true }}>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-12">
              Datenschutzerklärung
            </h1>

            <div className="prose prose-invert prose-lg max-w-none text-white/70">
              
              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">1. Datenschutz auf einen Blick</h2>
                
                <h3 className="text-xl font-medium text-white mt-6 mb-3">Allgemeine Hinweise</h3>
                <p className="leading-relaxed">
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                  personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                  Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>

                <h3 className="text-xl font-medium text-white mt-6 mb-3">Datenerfassung auf dieser Website</h3>
                <p className="leading-relaxed mb-4">
                  <strong className="text-white">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                  Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
                  Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" 
                  in dieser Datenschutzerklärung entnehmen.
                </p>

                <p className="leading-relaxed mb-4">
                  <strong className="text-white">Wie erfassen wir Ihre Daten?</strong><br />
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. 
                  Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
                  Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website 
                  durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. 
                  Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
                </p>

                <p className="leading-relaxed">
                  <strong className="text-white">Wofür nutzen wir Ihre Daten?</strong><br />
                  Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website 
                  zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet 
                  werden.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">2. Hosting</h2>
                <p className="leading-relaxed">
                  Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                </p>
                <p className="leading-relaxed mt-4">
                  Die Nutzung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein 
                  berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                
                <h3 className="text-xl font-medium text-white mt-6 mb-3">Datenschutz</h3>
                <p className="leading-relaxed">
                  Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                  Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den 
                  gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                </p>

                <h3 className="text-xl font-medium text-white mt-6 mb-3">Hinweis zur verantwortlichen Stelle</h3>
                <div className="bg-[#0A0A0A] border border-white/10 rounded-xl p-6 mt-4">
                  <p className="mb-2"><strong className="text-white">MCD Group GmbH</strong></p>
                  <p className="mb-2">Kieshecker Weg 141</p>
                  <p className="mb-4">40474 Düsseldorf</p>
                  <p className="mb-2">
                    Telefon:{' '}
                    <a href="tel:+4915126777707" className="text-[#D4AF37] hover:underline">
                      +49 151 26777707
                    </a>
                  </p>
                  <p>
                    E-Mail:{' '}
                    <a href="mailto:info@multicleandus.de" className="text-[#D4AF37] hover:underline">
                      info@multicleandus.de
                    </a>
                  </p>
                </div>

                <h3 className="text-xl font-medium text-white mt-6 mb-3">Speicherdauer</h3>
                <p className="leading-relaxed">
                  Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt 
                  wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die 
                  Datenverarbeitung entfällt.
                </p>

                <h3 className="text-xl font-medium text-white mt-6 mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                <p className="leading-relaxed">
                  Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung 
                  möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. 
                  Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom 
                  Widerruf unberührt.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">4. Datenerfassung auf dieser Website</h2>
                
                <h3 className="text-xl font-medium text-white mt-6 mb-3">Cookies</h3>
                <p className="leading-relaxed">
                  Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine 
                  Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder 
                  vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft 
                  (permanente Cookies) auf Ihrem Endgerät gespeichert.
                </p>
                <p className="leading-relaxed mt-4">
                  Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies 
                  informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies 
                  für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der 
                  Cookies beim Schließen des Browsers aktivieren.
                </p>

                <h3 className="text-xl font-medium text-white mt-6 mb-3">Kontaktformular</h3>
                <p className="leading-relaxed">
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus 
                  dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks 
                  Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. 
                  Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
                <p className="leading-relaxed mt-4">
                  Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                  sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur 
                  Durchführung vorvertraglicher Maßnahmen erforderlich ist.
                </p>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">5. Ihre Rechte</h2>
                <p className="leading-relaxed mb-4">
                  Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und 
                  Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem 
                  ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
                  <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                  <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                  <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                  <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                  <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
                </ul>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">6. SSL- bzw. TLS-Verschlüsselung</h2>
                <p className="leading-relaxed">
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung 
                  vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an 
                  uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine 
                  verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers 
                  von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                </p>
              </section>

              <div className="mt-12 pt-8 border-t border-white/10">
                <p className="text-white/50 text-sm">
                  Stand: Januar 2025
                </p>
                <Link
                  to="/impressum"
                  className="text-[#D4AF37] hover:underline mt-4 inline-block"
                >
                  Zum Impressum →
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};
